import { createRouter, createWebHashHistory } from "vue-router";

import informationRoutes from "./modules/informationRoutes";
import baseRoutes from "./modules/baseRoutes";
import orderRoutes from "./modules/orderRoutes";
import afterSaleRoutes from "./modules/afterSaleRoutes";
import distributionRoutes from "./modules/distributionRoutes";
import marketingRoutes from "./modules/marketingRoutes";
import balanceRoutes from "./modules/balanceRoutes";
import userRoutes from "./modules/userRoutes";
import authorityRoutes from "./modules/authorityRoutes";
import recordRoutes from "./modules/recordRoutes";

const routes = [
  // 数据中心
  ...informationRoutes,
  // 基础设置
  ...baseRoutes,
  // 订单管理
  ...orderRoutes,
  // 售后中心
  ...afterSaleRoutes,
  // 分销管理
  ...distributionRoutes,
  // 营销管理
  ...marketingRoutes,
  // 余额管理
  ...balanceRoutes,
  // 用户管理
  ...userRoutes,
  // 权限管理
  ...authorityRoutes,
  // 日志管理
  ...recordRoutes,

  {
    path: "/",
    redirect: "home",
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/HomeView.vue"),
    meta: {
      title: "工作台",
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/login.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/updatePassword",
    name: "updatePassword",
    component: () => import("@/views/login/updatePassword.vue"),
    meta: {
      title: "修改密码",
    },
  },

  // 404
  {
    path: "/:pathMatch(.*)*",
    redirect: "/notFound",
  },
  {
    path: "/notFound",
    name: "NotFound",
    component: () => import("@/views/notFound.vue"),
    meta: {
      title: "404",
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 全局前置守卫，这里可以加入用户登录判断
// router.beforeEach((to, from, next) => {
//   console.log(to)
//   console.log(from)
//   // 继续前进 next()
//   // 返回 false 以取消导航
//   next()
// })

// // // 全局后置钩子，这里可以加入改变页面标题等操作
router.afterEach((to, from) => {
  const _title = to.meta.title;
  if (_title) {
    window.document.title = "快递后台管理--" + _title;
  }
});

export default router;
